import { render, staticRenderFns } from "./BaseItemGroup.vue?vue&type=template&id=0a66d3cc&scoped=true&"
import script from "./BaseItemGroup.vue?vue&type=script&lang=js&"
export * from "./BaseItemGroup.vue?vue&type=script&lang=js&"
import style0 from "./BaseItemGroup.vue?vue&type=style&index=0&id=0a66d3cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a66d3cc",
  null
  
)

export default component.exports